import type { ReactNode } from 'react';

interface StatusLineProps {
  tone: 'active' | 'idle' | 'warn';
  children: ReactNode;
}

const TONE_DOT: Record<StatusLineProps['tone'], string> = {
  active: 'bg-[#6AA489]',
  idle: 'bg-white/30',
  warn: 'bg-[#D4A017]',
};

export function StatusLine({ tone, children }: StatusLineProps) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[12px] text-white/55">
      <span
        data-tone={tone}
        aria-hidden="true"
        className={`inline-block h-1.5 w-1.5 rounded-full ${TONE_DOT[tone]}`}
      />
      {children}
    </span>
  );
}
